import { Heading, Loader, Stepper } from "@/components";
import { Button } from "@/components/ui";
import useMyProfile from "./useMyProfile";
import { steps } from "./consts";
import { Step2, Step3, Step4 } from "./Steps";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import moment from "moment";

const MyProfile = () => {
  const {
    currentStep,
    onNextStepClick,
    onStepperClick,
    onPreviousStepClick,
    onTermsConditionClick,
    onDownloadProfileClick,
    userData,
    isRefetchingProfile
  } = useMyProfile();
  const isMobile = useIsMobile();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <div>
          <Heading title={"My Profile"} />
          <span className="text-g-500 text-[13px]">
            You have read and agreed to the Communacam
            <br />{" "}
            <span
              className="underline text-black font-[600] cursor-pointer"
              onClick={onTermsConditionClick}
            >
              Terms & Conditions
            </span>{" "}
            {userData?.readTermsDate ? (
              <span className="text-black font-[600]">
                on{" "}
                {moment(userData?.readTermsDate).format("MM/DD/YYYY")}
              </span>
            ) : (
              ""
            )}
          </span>
        </div>
       <div
          className={cn(
            isMobile
              ? "pt-3 flex flex-col gap-3"
              : "pt-6 px-6 flex items-center gap-15"
          )}
        >
          <Button onClick={onDownloadProfileClick} disabled={isRefetchingProfile}>
            {isRefetchingProfile ? <Loader variant="secondary" /> : <></>} Download Profile
          </Button>

          <Stepper
            steps={steps}
            currentStep={currentStep}
            onStepperClick={onStepperClick}
          />
        </div>
      </div>

      {currentStep == 1 ? (
        <Step2
          onNextClick={onNextStepClick}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 2 ? (
        <Step3
          onNextClick={onNextStepClick}
          onPreviousClick={onPreviousStepClick}
          onTermsConditionClick={onTermsConditionClick}
        />
      ) : currentStep == 3 ? (
        <Step4
          onNextClick={onNextStepClick}
          onPreviousClick={onPreviousStepClick}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MyProfile;
